import styled from 'styled-components';
import { Box } from '@mui/material';

const StyledFooter = styled(Box)(() => ({
    backgroundColor: '#232323',
    width: '100%',
    color: 'white',
    paddingTop: '60px',
    paddingBottom: '60px',
}));
export default StyledFooter;
